import { Component } from '@angular/core';

@Component({
  selector: 'app-return-to-home-button',
  templateUrl: './return-to-home-button.component.html',
  styleUrl: './return-to-home-button.component.scss'
})
export class ReturnToHomeButtonComponent {

}
